import React from "react";

export default function SortOrderIndicators(props) {
    let isCurrent = props.currentProperty === props.sortProperty;
    let isAsc = props.sortType === "asc";

    return (
        <div style={{ color: isCurrent ? "black" : "#ddd", marginLeft: 10 }}>
            <i className={isCurrent ? (isAsc ? "icon-chevron-down" : "icon-chevron-up") : "icon-chevron-down"} />
        </div>
    );
}